/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing intervals or laps during a workout, such as sprint repeats or track laps.`)
};

const es_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar intervalos o vueltas durante un entrenamiento, como series de sprints o vueltas de pista.`)
};

const de_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalle oder Runden bei einem Workout stoppen, etwa Sprint-Wiederholungen oder Bahnrunden.`)
};

const nl_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervallen of rondetijden timen tijdens een training, zoals sprintherhalingen of rondes op de baan.`)
};

const fr_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronométrer des intervalles ou des tours pendant un entraînement, comme des répétitions de sprint ou des tours de piste.`)
};

const it_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrare intervalli o giri durante un allenamento, come ripetute di sprint o giri in pista.`)
};

const pt_br2_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar intervalos ou voltas durante um treino, como repetições de sprint ou voltas na pista.`)
};

const pt_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar intervalos ou voltas durante um treino, como repetições de sprint ou voltas de pista.`)
};

const ja_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スプリントの反復やトラックのラップなど、ワークアウト中のインターバルやラップを計測する。`)
};

const zh_timer_stopwatch_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在锻炼中为间歇或圈数计时，比如冲刺重复训练或跑道计圈。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_use1", locale)
	if (locale === "en") return en_timer_stopwatch_use1(inputs)
	if (locale === "es") return es_timer_stopwatch_use1(inputs)
	if (locale === "de") return de_timer_stopwatch_use1(inputs)
	if (locale === "nl") return nl_timer_stopwatch_use1(inputs)
	if (locale === "fr") return fr_timer_stopwatch_use1(inputs)
	if (locale === "it") return it_timer_stopwatch_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_use1(inputs)
	if (locale === "pt") return pt_timer_stopwatch_use1(inputs)
	if (locale === "ja") return ja_timer_stopwatch_use1(inputs)
	return zh_timer_stopwatch_use1(inputs)
};